'use strict';

var w3cContext = require('@trustvc/w3c-context');
var assertions = require('./BitstringStatusList/assertions');

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const assertCredentialStatusType = /* @__PURE__ */ __name((type) => {
  const supportedTypes = [
    "StatusList2021Entry",
    "TransferableRecords"
  ];
  if (!supportedTypes.includes(type)) {
    throw new Error(`Unsupported type: ${type}`);
  }
}, "assertCredentialStatusType");
const assertCredentialStatusStatusListType = /* @__PURE__ */ __name((type) => {
  const supportedTypes = [
    "StatusList2021Entry"
  ];
  if (!supportedTypes.includes(type)) {
    throw new Error(`Unsupported type: ${type}`);
  }
}, "assertCredentialStatusStatusListType");
const assertStatusListIndex = /* @__PURE__ */ __name((statusListIndex) => {
  try {
    const index = Number.parseInt(statusListIndex);
    assertions.isNumber(index, "statusListIndex");
    assertions.isNonNegativeInteger(index, "statusListIndex");
  } catch (err) {
    throw new Error(`Invalid statusListIndex: Invalid Number: '${statusListIndex}'`);
  }
}, "assertStatusListIndex");
const assertStatusPurposeMatches = /* @__PURE__ */ __name((statusList, statusPurpose) => {
  if (statusList.statusPurpose !== statusPurpose) {
    throw new Error(`statusPurpose does not match the statusPurpose in the statusListCredential`);
  }
}, "assertStatusPurposeMatches");
const assertCredentialStatus = /* @__PURE__ */ __name((credentialStatus) => {
  switch (credentialStatus.type) {
    case "StatusList2021Entry":
      assertStatusList2021Entry(credentialStatus);
      break;
    default:
      throw new Error(`Unsupported type: ${credentialStatus.type}`);
  }
}, "assertCredentialStatus");
function _validateUriId({ id, propertyName }) {
  let parsed;
  try {
    parsed = new URL(id);
  } catch (e) {
    const error = new Error(`"${propertyName}" must be a URI: "${id}".`);
    throw error;
  }
  if (!parsed.protocol) {
    throw new Error(`"${propertyName}" must be a URI: "${id}".`);
  }
}
__name(_validateUriId, "_validateUriId");
const assertStatusList2021Entry = /* @__PURE__ */ __name((credentialStatus) => {
  const { type, statusPurpose, statusListIndex, statusListCredential } = credentialStatus;
  assertCredentialStatusType(type);
  assertions.assertAllowedStatusPurpose(statusPurpose);
  assertStatusListIndex(statusListIndex);
  _validateUriId({
    id: statusListCredential,
    propertyName: "credentialStatus.statusListCredential"
  });
}, "assertStatusList2021Entry");
const assertTransferableRecords = /* @__PURE__ */ __name((credentialStatus, mode = "verify") => {
  const { type, tokenId, tokenNetwork: { chain, chainId }, tokenRegistry } = credentialStatus;
  assertCredentialStatusType(type);
  if (tokenId && mode === "sign") {
    throw new Error(`"tokenId" is a generated field and should not be included in the credential status.`);
  } else if (mode === "verify") {
    assertions.isString(tokenId, "credentialStatus.tokenId");
  }
  assertions.isString(tokenRegistry, "credentialStatus.tokenRegistry");
  assertions.isString(chain, "credentialStatus.tokenNetwork.chain");
  assertions.isNumber(Number(chainId), "credentialStatus.tokenNetwork.chainId");
}, "assertTransferableRecords");
const fetchCredentialStatusVC = /* @__PURE__ */ __name(async (url, documentLoader) => {
  if (!url || !URL.canParse(url)) {
    throw new Error(`Invalid statusListCredential: "${url}"`);
  }
  try {
    documentLoader = documentLoader ?? await w3cContext.getDocumentLoader();
    const result = (await documentLoader(url))?.document;
    return result;
  } catch (err) {
    if (!(err instanceof Error)) {
      throw new Error(`Failed to fetch Credential Status VC`);
    }
    throw new Error(`Credential Status VC not found: ${err?.message}`);
  }
}, "fetchCredentialStatusVC");
const getValidFromDateFromCredentialStatusVC = /* @__PURE__ */ __name(async (url) => {
  const defaultValidFrom = (/* @__PURE__ */ new Date()).toISOString();
  try {
    const signedCredentialStatusVC = await fetchCredentialStatusVC(url);
    return signedCredentialStatusVC?.validFrom ?? defaultValidFrom;
  } catch (err) {
    return defaultValidFrom;
  }
}, "getValidFromDateFromCredentialStatusVC");

exports._validateUriId = _validateUriId;
exports.assertCredentialStatus = assertCredentialStatus;
exports.assertCredentialStatusStatusListType = assertCredentialStatusStatusListType;
exports.assertCredentialStatusType = assertCredentialStatusType;
exports.assertStatusList2021Entry = assertStatusList2021Entry;
exports.assertStatusListIndex = assertStatusListIndex;
exports.assertStatusPurposeMatches = assertStatusPurposeMatches;
exports.assertTransferableRecords = assertTransferableRecords;
exports.fetchCredentialStatusVC = fetchCredentialStatusVC;
exports.getValidFromDateFromCredentialStatusVC = getValidFromDateFromCredentialStatusVC;
